import React, { useState } from 'react';
import PropTypes from 'prop-types';
import copyToClipboard from 'copy-to-clipboard';
import { useMediaQuery } from 'react-responsive';

import { makeOwnerMarketingPageUrl } from 'common/partnerHelpers';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrExternalLink from 'client/components/SrExternalLink';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';
import SrButton, { SR_BUTTON_THEME_ADOBE_BLUE } from 'client/components/SrButton/SrButton';

const HowToTalkToClientsAboutSunroom = ({ partner, appUrl }) => {
  const [buttonClicked, setButtonClicked] = useState(false);

  const link = makeOwnerMarketingPageUrl(partner, appUrl);

  const onClickCopyToClipboard = () => {
    copyToClipboard(link);
    setButtonClicked(true);
    setTimeout(() => setButtonClicked(false), 1500);
  };

  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrBox boxSizing="border-box" maxWidth={isSmallScreen ? '100%' : '350px'}>
      <SrText
        font="greycliff"
        color="blueGreycliff"
        size="40"
        lineHeight="45px"
        weight="700"
        display="block"
      >
        How to talk to your clients about Sunroom
      </SrText>
      <SrBox marginTop="30px">
        <SrText font="greycliff" color="blueGreycliff" size="16" lineHeight="25px" weight="600">
          Share the link to your personalized Sunroom marketing page and show your clients how
          Sunroom works!
        </SrText>
      </SrBox>
      <SrExternalLink link={link}>
        <SrFlex marginTop="30px" align="start" cursor="pointer">
          <SrText
            font="greycliff"
            color="blue300"
            size="16"
            lineHeight="25px"
            weight="600"
            decoration="underline"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            {link}
          </SrText>
          <SrBox margin="6px 0 0 8px">
            <SrIcon className="external-link-blue" />
          </SrBox>
        </SrFlex>
      </SrExternalLink>
      <SrBox maxWidth={isSmallScreen ? null : '210px'} marginTop="26px">
        <SrButton theme={SR_BUTTON_THEME_ADOBE_BLUE} onClick={onClickCopyToClipboard} hasBoxShadow>
          {buttonClicked ? 'Copied!' : 'Share'}
        </SrButton>
      </SrBox>
    </SrBox>
  );
};

HowToTalkToClientsAboutSunroom.propTypes = {
  appUrl: PropTypes.string.isRequired,
  partner: PropTypes.object.isRequired,
};

HowToTalkToClientsAboutSunroom.displayName = 'HowToTalkToClientsAboutSunroom';

export default HowToTalkToClientsAboutSunroom;
